export class factoryWorkerHk {
    employersName: string;
    place: string;
    position: string;
    date: string;
}